module.exports = __webpack_public_path__ + "img/bg_intro_2_6_mb.71ad95de.png";